export const getLabelReviewInci = ({ labelReviewWizard }) => labelReviewWizard.labelReviewInci;
